import { render } from "./SectionSix.vue?vue&type=template&id=9a221d8c&ts=true"
import script from "./SectionSix.vue?vue&type=script&lang=ts"
export * from "./SectionSix.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__